var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "position-absolute w-100 h-100" },
    [
      _c(
        "div",
        { staticClass: "w-100 pt-90 p-50 align-items-center uloha-wrap" },
        [
          _c("h3", { staticClass: "pl-100 pr-100 mb-0" }, [
            _vm._v(_vm._s(_vm.otazka.zadanie))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-50 w-100" },
            [
              _vm.otazka.otazka_typ === "radio"
                ? [
                    _vm.isVideo(_vm.otazka.subor)
                      ? [
                          _c(
                            "div",
                            { staticClass: "question-grid one-third-question" },
                            [
                              _c("div", { staticClass: "position-relative" }, [
                                _c(
                                  "div",
                                  { staticClass: "rounded-10 overflow-hidden" },
                                  [
                                    _c(
                                      "skoly-ulohy-kvizova-otazka-video-thumbnail",
                                      { attrs: { subor: _vm.otazka.subor } }
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "play-btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.showVideo(_vm.otazka.subor)
                                      }
                                    }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "icon icon--play"
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("skoly-ulohy-kvizova-otazka-moznosti", {
                                attrs: {
                                  otazka: _vm.otazka,
                                  "show-result": _vm.showResult,
                                  odpoved: _vm.odpoved
                                },
                                on: { playVideo: _vm.showVideo }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm.isAudio(_vm.otazka.subor)
                      ? [
                          _c(
                            "div",
                            { staticClass: "question-grid one-third-question" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "bg-light-brown p-30 --rounded"
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-white text-bold text-dark text-left mb-15"
                                    },
                                    [_vm._v("Prehrajte si zvuk")]
                                  ),
                                  _vm._v(" "),
                                  _c("skoly-ulohy-kvizova-otazka-audio", {
                                    attrs: { subor: _vm.otazka.subor }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("skoly-ulohy-kvizova-otazka-moznosti", {
                                attrs: {
                                  otazka: _vm.otazka,
                                  "show-result": _vm.showResult,
                                  odpoved: _vm.odpoved
                                },
                                on: { playVideo: _vm.showVideo }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm.isImage(_vm.otazka.subor)
                      ? [
                          _c(
                            "div",
                            { staticClass: "question-grid mb-35" },
                            [
                              _vm.otazka.subor
                                ? _c("img", {
                                    staticClass: "img-fluid rounded-10",
                                    attrs: {
                                      src: _vm.skolyStorage + _vm.otazka.subor,
                                      alt: ""
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("skoly-ulohy-kvizova-otazka-moznosti", {
                                attrs: {
                                  otazka: _vm.otazka,
                                  "show-result": _vm.showResult,
                                  odpoved: _vm.odpoved
                                },
                                on: { playVideo: _vm.showVideo }
                              })
                            ],
                            1
                          )
                        ]
                      : [
                          _c("skoly-ulohy-kvizova-otazka-moznosti", {
                            staticClass: "question-grid cols-answers-3",
                            attrs: {
                              otazka: _vm.otazka,
                              "show-result": _vm.showResult,
                              odpoved: _vm.odpoved
                            },
                            on: { playVideo: _vm.showVideo }
                          })
                        ]
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "question-grid answers-below" },
                      [
                        _vm.isVideo(_vm.otazka.subor)
                          ? [
                              _c(
                                "div",
                                { staticClass: "position-relative w-40" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "rounded-10 overflow-hidden"
                                    },
                                    [
                                      _c(
                                        "skoly-ulohy-kvizova-otazka-video-thumbnail",
                                        { attrs: { subor: _vm.otazka.subor } }
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "play-btn",
                                      on: {
                                        click: function($event) {
                                          return _vm.showVideo(_vm.otazka.subor)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "icon icon--play"
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          : _vm.isAudio(_vm.otazka.subor)
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "bg-light-brown p-30 --rounded d-flex align-items-center w-720"
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-white text-bold text-dark text-left mb-0 mr-30 flex-0"
                                    },
                                    [_vm._v("Prehrajte si zvuk")]
                                  ),
                                  _vm._v(" "),
                                  _c("skoly-ulohy-kvizova-otazka-audio", {
                                    attrs: { subor: _vm.otazka.subor }
                                  })
                                ],
                                1
                              )
                            ]
                          : [
                              _c(
                                "div",
                                {
                                  staticClass: "position-relative w-360 h-240"
                                },
                                [
                                  _vm.otazka.subor
                                    ? _c("img", {
                                        staticClass: "img-fluid rounded-10",
                                        attrs: {
                                          src:
                                            _vm.skolyStorage + _vm.otazka.subor,
                                          alt: ""
                                        }
                                      })
                                    : _vm._e()
                                ]
                              )
                            ],
                        _vm._v(" "),
                        _c("b-textarea", {
                          class: {
                            valid:
                              _vm.showResult &&
                              _vm.otazka.textove_varianty.includes(
                                _vm.odpoved.input
                              ),
                            invalid:
                              _vm.showResult &&
                              !_vm.otazka.textove_varianty.includes(
                                _vm.odpoved.input
                              )
                          },
                          attrs: {
                            rows: "3",
                            placeholder: "Napíšte svoju odpoveď ...",
                            disabled: _vm.showResult
                          },
                          model: {
                            value: _vm.odpoved.input,
                            callback: function($$v) {
                              _vm.$set(_vm.odpoved, "input", $$v)
                            },
                            expression: "odpoved.input"
                          }
                        }),
                        _vm._v(" "),
                        _vm.showResult &&
                        !_vm.otazka.textove_varianty.includes(_vm.odpoved.input)
                          ? _c("p", { staticClass: "mb-0" }, [
                              _c("strong", { staticClass: "text-success" }, [
                                _vm._v("Akceptované odpovede:")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.otazka.textove_varianty.join(", "))
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c("skoly-ulohy-kvizova-otazka-button", {
            attrs: { "show-result": _vm.showResult, odpoved: _vm.odpoved },
            on: { next: _vm.next, checkResponse: _vm.checkResponse }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("skoly-ulohy-kvizova-otazka-video", {
        attrs: { subor: _vm.videoToPlay }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }